global.Buffer = global.Buffer || require("buffer").Buffer;

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import mixin from "./mixin";
import Axios from "axios";
import VueRouter from "vue-router";
import "./../public/tailwind.css";
import VueSweetalert2 from "vue-sweetalert2";
import GA4Plugin from "./plugins/ga4";

import "sweetalert2/dist/sweetalert2.min.css";

// Font Awesome
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(fas, far);
// eslint-disable-next-line vue/multi-word-component-names
Vue.component("fa", FontAwesomeIcon);

// Configure SweetAlert2 to prevent height changes
const swalOptions = {
  backdrop: true,
  heightAuto: false,
  allowOutsideClick: true,
  allowEscapeKey: true,
  customClass: {
    container: "swal2-container-custom",
  },
};

Vue.use(VueSweetalert2, swalOptions);
Vue.use(GA4Plugin);

import {
  refreshToken,
  clearUserSession,
  setupAutoRefreshToken,
} from "./services/auth";

Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.mixin(mixin);
Axios.defaults.baseURL = process.env.VUE_APP_URLAPP;

setupAutoRefreshToken();

Axios.interceptors.request.use(
  async (config) => {
    config.timeout = 10000;
    config.timeoutErrorMessage = "Time Out";
    const user = store.get("user");
    if (!config.headers) {
      config.headers = {};
    }
    if (user) {
      const accessToken = user["access_token"] || user["accessToken"];
      if (!config.headers["Authorization"] && accessToken) {
        config.headers["Authorization"] = `Bearer ${accessToken}`;
      }
      if (!config.headers["Content-type"] && !config.headers["Content-Type"]) {
        config.headers["Content-type"] = "application/json";
      }
    } else {
      try {
        let wait = 0;
        while (!window["flutter_inappwebview"]) {
          setTimeout(() => {}, 100);
          if (wait++ >= 100) {
            break;
          }
        }
        const flutter = window["flutter_inappwebview"];
        const res = await flutter.callHandler("getdata", "loginResponse");
        if (res && (res["access_token"] || res["accessToken"])) {
          const token = res["access_token"] || res["accessToken"];
          if (res["salehistory_url"]) {
            store.set("salehistory_url", res["salehistory_url"]);
          }
          store.set("user", res);
          config.headers["Authorization"] = `Bearer ${token}`;
        }
      } catch (e) {
        console.error("erroraccesstoken", JSON.stringify(e));
      }
    }
    // if (config.url && config.url.includes("/api/Users/RefreshToken")) {
    //   delete config.headers["Authorization"];
    // }
    return config;
  },
  (error) => {
    return Promise.reject("request", error);
  },
);

Axios.interceptors.response.use(
  (response) => {
    if (response.status == 200) {
      return Promise.resolve(response.data);
    } else {
      return Promise.reject(response);
    }
  },
  async (error) => {
    const originalRequest = error.config;
    const is401 =
      (error.response && error.response.status === 401) ||
      (error.message && error.message.includes("status code 401"));

    if (is401) {
      const url = (originalRequest && originalRequest.url) || "";
      const isAuthUrl =
        url.includes("/api/Users/login") ||
        url.includes("/api/Users/RefreshToken") ||
        url.includes("/api/Users/registerUser") ||
        url.includes("/api/Users/VerifyregisterUserOTP") ||
        url.includes("/api/Users/VerifyBeforeRegister");

      if (
        originalRequest &&
        !originalRequest._retry &&
        !originalRequest._skipAuthRefresh &&
        !isAuthUrl
      ) {
        const user = store.get("user");
        const token =
          user?.refresh_token ||
          user?.refreshToken ||
          user?.token ||
          user?.access_token ||
          user?.accessToken;

        if (token) {
          originalRequest._retry = true;
          try {
            const newAccessToken = await refreshToken();
            if (newAccessToken) {
              if (
                originalRequest.headers &&
                typeof originalRequest.headers.set === "function"
              ) {
                originalRequest.headers.set(
                  "Authorization",
                  `Bearer ${newAccessToken}`,
                );
              } else {
                if (!originalRequest.headers) {
                  originalRequest.headers = {};
                }
                originalRequest.headers[
                  "Authorization"
                ] = `Bearer ${newAccessToken}`;
              }
              return Axios(originalRequest);
            }
          } catch (refreshErr) {
            await clearUserSession();
            return Promise.reject(refreshErr);
          }
        }
      }

      if (!url.includes("/api/Users/login")) {
        await clearUserSession();
      }
    }

    return Promise.reject(error);
  },
);

// Global active-press class toggler to bypass WebView touchstart preventDefault :active issues
if (typeof document !== "undefined") {
  const addActive = (e) => {
    const target = e.target.closest(
      ".clickable, button, .btn, [role='button']",
    );
    if (target && !target.disabled && !target.classList.contains("disabled")) {
      target.classList.add("active-press");
    }
  };

  const removeActive = (e) => {
    const target = e.target.closest(
      ".clickable, button, .btn, [role='button']",
    );
    if (target) {
      target.classList.remove("active-press");
    }
  };

  const removeAllActive = () => {
    document.querySelectorAll(".active-press").forEach((el) => {
      el.classList.remove("active-press");
    });
  };

  document.addEventListener("touchstart", addActive, { passive: true });
  document.addEventListener("touchend", removeActive, { passive: true });
  document.addEventListener("touchcancel", removeActive, { passive: true });
  document.addEventListener("mousedown", addActive, { passive: true });
  document.addEventListener("mouseup", removeAllActive, { passive: true });
  document.addEventListener("mouseleave", removeAllActive, { passive: true });
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
